/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Adv_6Inputs */

const en_pc_cmp_adv_6 = /** @type {(inputs: Pc_Cmp_Adv_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scriptable through a CLI and an MCP server for automation and AI agents.`)
};

const zh_pc_cmp_adv_6 = /** @type {(inputs: Pc_Cmp_Adv_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过 CLI 和 MCP 服务器支持自动化与 AI 智能体。`)
};

/**
* | output |
* | --- |
* | "Scriptable through a CLI and an MCP server for automation and AI agents." |
*
* @param {Pc_Cmp_Adv_6Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_adv_6 = /** @type {((inputs?: Pc_Cmp_Adv_6Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Adv_6Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_adv_6(inputs)
	return zh_pc_cmp_adv_6(inputs)
});
export { pc_cmp_adv_6 as "pc.cmp.adv.6" }